import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractTraumatologySummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const traumatology = specialtyData.traumatologia;
  if (!traumatology || typeof traumatology !== 'object') return null;

  const mobility = (traumatology as { mobility_restrictions?: unknown }).mobility_restrictions;
  if (typeof mobility !== 'string' || mobility.trim() === '') return null;

  return `Traumatología: restricciones de movilidad - ${mobility.trim()}.`;
};

export function TraumatologyPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const traumatologySummary = extractTraumatologySummary(props.specialtyData);

  if (!traumatologySummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${traumatologySummary}\n${props.consultation.general_recommendations}`
    : traumatologySummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
